import React, { useContext } from "react";
import sld from "../../images/sld/Rectangle.svg";
import Ecc from "../../components/ISLANDABLE/Ecc";
import Busbar from "../../components/ISLANDABLE/Busbar";
import Utility from "../../components/ISLANDABLE/Utility";
import Genset from "../../components/ISLANDABLE/Genset";
import Battery from "../../components/ISLANDABLE/Battery";
import PV1 from "../../components/ISLANDABLE/PV1";
import PV2 from "../../components/ISLANDABLE/PV2";
import PV3 from "../../components/ISLANDABLE/PV3";
import CHP from "../../components/ISLANDABLE/CHP";
import Load from "../../components/ISLANDABLE/Load";
import Ev from "../../components/ISLANDABLE/Ev";
import Linebar from "../../components/GRIDCONNECTED/Linebar";
import embLabels from "../../config/emb-labels-en.json";

import { DesignAssetContext } from "../CustomHooks/ContextApi"; 
import { uniqueId } from "lodash";
import LoadPvBess from "../../components/GensetPvBess/LoadPvBess";

const IslandableSLD = () => {
  const {
    CBAssetList,
    CBEVList,
    CBLoadList,
    sldLoadCompleted,
    projectKind,
    switchboardType,
    coordinates,
    count,
    loadSide
  } = useContext(DesignAssetContext);
  const areAllConfigured = () =>{
    return CBLoadList.every(item => item.uiData.configured);
  }
  // Helper function to get component presence flags
  const getComponentFlags = () => ({
    isExisting: switchboardType === embLabels?.EXISTING_SWITCHBOARD,
    hasLoad: CBLoadList && CBLoadList.length > 0,
    hasEV: CBEVList && CBEVList.some((ev) => ev.uiData.status),
    derCount: count?.derCount || 0,
    evCount: count?.evCount || 0,
  });
  const isLoadSide = loadSide === "LOAD_SIDE";
   const POSITION_CONFIG = {
    EXISTING_SWITCHBOARD: {
      load: {
        base: { 6: 110, 5: 110, 4: 120, 3: 100, default: 0 },
        withEV: {
          6: `${isLoadSide ? 50 : 180}`,
          5: `${isLoadSide ? 90 : 170}`,
          4: `${isLoadSide ? 110 : 160}`,
          3: `${isLoadSide ? 100 : 150}`,
          default: 0
        },
      },
      ev: {
        withLoad: { 6: 170, 5: 140, 4: 70, 3: 50, default: 0 },
      },
    },
    NEW_SWITCHBOARD: {
      load: {
        base: { 6: -65, 5: -65, 4: -50, 3: 0, default: 0 },
        withEV: { 6: -70, 5: -70, 4: -64, 3: -30, default: 0 },
      },
      ev: {
        withLoad: { 6: 300, 5: 230, 4: 200, 3: 150, default: 0 },
      },
     
    },
  };
  const getEVXPosition = () => {
    const { isExisting, hasLoad, derCount } = getComponentFlags();

    // Get the appropriate config based on switchboard type
    const config = isExisting
      ? POSITION_CONFIG.EXISTING_SWITCHBOARD.ev
      : POSITION_CONFIG.NEW_SWITCHBOARD.ev;


    // Scenario: Load present without GT
    if (hasLoad &&  config.withLoad) {
      return config.withLoad[derCount] ?? config.withLoad.default;
    }

    // If EV exists but load isn't present, use withLoad position as fallback
    return config.withLoad?.[derCount] ?? config.withLoad?.default ?? 0;
  };

  const getLoadXPosition = () => {
    const { isExisting, derCount, hasEV} = getComponentFlags();

    // Get the appropriate config based on switchboard type
    const config = isExisting
      ? POSITION_CONFIG.EXISTING_SWITCHBOARD.load
      : POSITION_CONFIG.NEW_SWITCHBOARD.load;

    if (hasEV) {
      return config.withEV[derCount] ?? config.withEV.default;
    }
    // Scenario 1: Base position (no EV, no GT)
    return config.base[derCount] ?? config.base.default;
  };
  return (
    <div
      id="SLD-Image"
      className="col-sm-12 col-md-12 col-lg-12 col-xl-12 px-0"
    >
      <svg viewBox="0 0 1400 800">
        <g>
          <svg x="0" y="0" viewBox="0 0 1400 800">
            <g id="grid">
              <svg>
                <image href={sld} x="0" y="0" />
              </svg>
            </g>
            <svg x="0" y="0" viewBox="0 0 1400 800">
            <g
              id="components-sld"
              style={sldLoadCompleted ? {} : { display: "none" }}
            >
              <Ecc />
              <Busbar secondBusbar={true} />
              {projectKind?.isMgaasIecIsland &&
                switchboardType === embLabels?.EXISTING_SWITCHBOARD && (
                  <Linebar key={uniqueId()} />
                )}
              <Utility />
              {CBAssetList[1].uiData.status && <Genset />}
              {CBAssetList[2].uiData.status && <Battery />}
              {CBAssetList[3].uiData.status && <PV1 />}
              {CBAssetList[4].uiData.status && <PV2 />}
              {CBAssetList[5].uiData.status && <PV3 />}
              {CBAssetList[6].uiData.status && <CHP />}
              <svg
                id="load pointer"
                x={
                  // count?.evCount === 1 && switchboardType === embLabels?.EXISTING_SWITCHBOARD
                  //   ? count?.derCount ===6
                  //   ? loadSide ==="LOAD_SIDE"?"50":"200"
                  //   : count?.derCount ===5
                  //   ?loadSide ==="LOAD_SIDE"?"80":"165"
                  //   :count?.derCount ===4
                  //   ?loadSide ==="LOAD_SIDE"?"130":"180"
                  //   :loadSide ==="LOAD_SIDE"?"125":"155"
                  //   : switchboardType === embLabels?.EXISTING_SWITCHBOARD ? "120"
                    
                  //   :  count?.evCount === 1?
                  //   count?.derCount ===6
                  //   ?-100
                  //   : count?.derCount ===5
                  //   ?-60
                  //   :count?.derCount ===4
                  //   ?-60
                  //   :-50:"0"
                  getLoadXPosition()
                }
                y="0"
              >
               
                {CBLoadList.length > 0 &&
                              <LoadPvBess
                              loadLength = {count}
                                configured = {areAllConfigured()}
                              />
                            }
              </svg>
             <svg x={
              // count?.derCount === 6 
              // ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?200:300
              // :count?.derCount === 5
              // ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?155:260
              // :count?.derCount === 4
              // ?switchboardType === embLabels?.EXISTING_SWITCHBOARD?90:200
              // :count?.derCount === 3
              // ? count?.evCount === 1?embLabels?.EXISTING_SWITCHBOARD?80:135:70
              // :0
              getEVXPosition()
             } y="0">
              {CBEVList.map(
                (cbData, key) =>
                  cbData.uiData.status && (
                    <Ev key={cbData.configData.name} index={key} />
                  )
              )}
              </svg>
            </g>
            </svg>
          </svg>
        </g>
      </svg>
    </div>
  );
};

export default IslandableSLD;
